var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useMemo, useState } from "react";
import { Routes, Route, Navigate, useMatch } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Footer, Header, NotFoundScreen, PageBanner } from "@sequentech/ui-essentials";
import { applyConfigurationLanguagePolicy, ETranslationScope, overwriteTranslations, setCookie, USER_LANGUAGE_COOKIE_NAME, getValueFromCookie, } from "@sequentech/ui-core";
import { HomeScreen } from "./screens/HomeScreen";
import { ConfirmationScreen } from "./screens/ConfirmationScreen";
import Stack from "@mui/material/Stack";
import { provideBallotService } from "./services/BallotService";
import { AuthContext } from "./providers/AuthContextProvider";
import { RouteParameterProvider } from "./providers/RouteParameterProvider";
import { ApolloContextProvider, ApolloWrapper } from "./providers/ApolloContextProvider";
import { LoginScreen } from "./screens/LoginScreen";
import { SettingsContext } from "./providers/SettingsContextProvider";
import { useAppSelector } from "./store/hooks";
import { selectBallotStyleByElectionEventId } from "./store/ballotStyles/ballotStylesSlice";
import SequentLogo from "@sequentech/ui-essentials/public/Sequent_logo.svg";
import BlankLogoImg from "@sequentech/ui-essentials/public/blank_logo.svg";
var StyledAppWrapper = styled(Stack)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var customCss = _a.customCss;
    return customCss;
});
var StyledApp = styled(Stack)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-height: 100vh;\n"], ["\n    min-height: 100vh;\n"])));
var HeaderWithContext = function () {
    var _a, _b, _c;
    var authContext = useContext(AuthContext);
    var globalSettings = useContext(SettingsContext).globalSettings;
    var routeMatch = useMatch("/tenant/:tenantId/event/:eventId/*");
    var ballotStyle = useAppSelector(selectBallotStyleByElectionEventId(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.params.eventId));
    var presentation = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_event_presentation;
    var languagesList = (_b = (_a = presentation === null || presentation === void 0 ? void 0 : presentation.language_conf) === null || _a === void 0 ? void 0 : _a.enabled_language_codes) !== null && _b !== void 0 ? _b : ["en"];
    var showUserProfile = (_c = presentation === null || presentation === void 0 ? void 0 : presentation.show_user_profile) !== null && _c !== void 0 ? _c : true;
    var logoImg = (presentation === null || presentation === void 0 ? void 0 : presentation.logo_url) === undefined
        ? BlankLogoImg
        : (presentation === null || presentation === void 0 ? void 0 : presentation.logo_url) === null
            ? SequentLogo
            : presentation === null || presentation === void 0 ? void 0 : presentation.logo_url;
    var onChangeLanguage = function (lang) {
        if (getValueFromCookie(USER_LANGUAGE_COOKIE_NAME) !== lang) {
            setCookie(USER_LANGUAGE_COOKIE_NAME, lang);
        }
    };
    return (_jsx(Header, { appVersion: { main: globalSettings.APP_VERSION }, appHash: { main: globalSettings.APP_HASH }, userProfile: {
            firstName: authContext.firstName,
            username: authContext.username,
            email: authContext.email,
            openLink: showUserProfile ? authContext.openProfileLink : undefined,
        }, logoutFn: authContext.isAuthenticated ? authContext.logout : undefined, languagesList: languagesList, logoUrl: logoImg, onChangeLanguage: onChangeLanguage }));
};
var App = function () {
    var _a, _b;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _c = useState(null), confirmationBallot = _c[0], setConfirmationBallot = _c[1];
    var _d = useState(""), ballotId = _d[0], setBallotId = _d[1];
    var _e = useState(""), fileName = _e[0], setFileName = _e[1];
    var ballotService = provideBallotService();
    var routeMatch = useMatch("/tenant/:tenantId/event/:eventId/*");
    var currentEventId = routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.params.eventId;
    var ballotStyle = useAppSelector(selectBallotStyleByElectionEventId(currentEventId));
    // Offline verification can still use public presentation metadata. It must
    // never need an authenticated ballot-style query or block local import.
    var tenantId = routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.params.tenantId;
    var publicConfigUrl = globalSettings.DISABLE_AUTH && tenantId && currentEventId
        ? "".concat(globalSettings.PUBLIC_BUCKET_URL, "tenant-").concat(tenantId, "/event-").concat(currentEventId, "/election_event_config.json")
        : undefined;
    var _f = useState(), publicConfig = _f[0], setPublicConfig = _f[1];
    useEffect(function () {
        if (!publicConfigUrl)
            return;
        var controller = new AbortController();
        var active = true;
        void (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, config, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch(publicConfigUrl, { signal: controller.signal })];
                    case 1:
                        response = _b.sent();
                        if (!response.ok)
                            return [2 /*return*/];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        config = _b.sent();
                        if (active &&
                            config.tenant_id === tenantId &&
                            config.election_event_id === currentEventId) {
                            setPublicConfig({
                                url: publicConfigUrl,
                                presentation: config.election_event_presentation,
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            active = false;
            controller.abort();
        };
    }, [publicConfigUrl, tenantId, currentEventId]);
    var presentation = (_b = (_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _a === void 0 ? void 0 : _a.election_event_presentation) !== null && _b !== void 0 ? _b : ((publicConfig === null || publicConfig === void 0 ? void 0 : publicConfig.url) === publicConfigUrl ? publicConfig === null || publicConfig === void 0 ? void 0 : publicConfig.presentation : undefined);
    useEffect(function () {
        setConfirmationBallot(null);
        setBallotId("");
        setFileName("");
    }, [currentEventId]);
    useEffect(function () {
        overwriteTranslations(presentation, {
            scope: ETranslationScope.BALLOT_VERIFIER,
            changeDefaultLanguage: false,
        });
        applyConfigurationLanguagePolicy(presentation);
        return function () {
            overwriteTranslations(undefined, {
                scope: ETranslationScope.BALLOT_VERIFIER,
                changeDefaultLanguage: false,
            });
        };
    }, [presentation]);
    var customCss = useMemo(function () {
        var _a, _b, _c, _d, _e, _f;
        return (_f = (_c = (_b = (_a = confirmationBallot === null || confirmationBallot === void 0 ? void 0 : confirmationBallot.election_config) === null || _a === void 0 ? void 0 : _a.election_event_presentation) === null || _b === void 0 ? void 0 : _b.css) !== null && _c !== void 0 ? _c : (_e = (_d = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _d === void 0 ? void 0 : _d.election_event_presentation) === null || _e === void 0 ? void 0 : _e.css) !== null && _f !== void 0 ? _f : "";
    }, [confirmationBallot, ballotStyle]);
    return (_jsx(StyledAppWrapper, { customCss: customCss, children: _jsxs(StyledApp, { className: "ballot-verifier app-root", children: [globalSettings.DISABLE_AUTH ? _jsx(Header, {}) : _jsx(HeaderWithContext, {}), _jsx(PageBanner, { marginBottom: "auto", component: "main", id: "main-content", tabIndex: -1, children: _jsxs(Routes, { children: [_jsx(Route, { path: "*", element: _jsx(NotFoundScreen, {}) }), _jsx(Route, { path: "/", element: _jsx(Navigate, { replace: true, to: "/tenant/".concat(globalSettings.DEFAULT_TENANT_ID, "/event/").concat(globalSettings.DEFAULT_EVENT_ID, "/").concat(globalSettings.DISABLE_AUTH ? "start" : "login") }) }), _jsx(Route, { path: "/tenant/:tenantId/event/:eventId/login", element: _jsx(RouteParameterProvider, { children: _jsx(ApolloContextProvider, { children: _jsx(ApolloWrapper, { children: _jsx(LoginScreen, {}) }) }) }) }), _jsx(Route, { path: "/tenant/:tenantId/event/:eventId/start", element: _jsx(RouteParameterProvider, { children: _jsx(ApolloContextProvider, { children: _jsx(ApolloWrapper, { children: _jsx(HomeScreen, { confirmationBallot: confirmationBallot, setConfirmationBallot: setConfirmationBallot, ballotId: ballotId, setBallotId: setBallotId, fileName: fileName, setFileName: setFileName, ballotService: ballotService }) }) }) }) }), _jsx(Route, { path: "/tenant/:tenantId/event/:eventId/confirmation", element: _jsx(RouteParameterProvider, { children: _jsx(ApolloContextProvider, { children: _jsx(ApolloWrapper, { children: _jsx(ConfirmationScreen, { confirmationBallot: confirmationBallot, ballotId: ballotId }) }) }) }) })] }) }), _jsx(Footer, {})] }) }));
};
export default App;
var templateObject_1, templateObject_2;
